import { render } from "./verify-phone.vue?vue&type=template&id=0a9131b8&scoped=true"
import script from "./verify-phone.vue?vue&type=script&lang=js"
export * from "./verify-phone.vue?vue&type=script&lang=js"

import "./verify-phone.vue?vue&type=style&index=0&id=0a9131b8&lang=scss&scoped=true"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9131b8"]])

export default __exports__